import { api } from 'services/companiesApi';

export const getFiles = async (filters?: any) => {
	return await api.get('/me/assets', { params: filters });
};
